module.exports = __webpack_public_path__ + "img/bj.95d787ec.png";